export default __webpack_public_path__ + "static/media/google.768d15f9.svg";